import { ShieldIcon } from '@/lib/navigation';

import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

type AdminUserRow = {
  name: string;
  email: string;
  role: 'Admin' | 'Member';
  status: 'Active' | 'Invited';
  initials: string;
};

const userRows: AdminUserRow[] = [
  { name: 'Ada Lovelace', email: 'ada.lovelace@example.com', role: 'Admin', status: 'Active', initials: 'AL' },
  { name: 'Grace Hopper', email: 'grace.hopper@example.com', role: 'Member', status: 'Active', initials: 'GH' },
  { name: 'Alan Turing', email: 'alan.turing@example.com', role: 'Member', status: 'Active', initials: 'AT' },
  { name: 'Katherine Johnson', email: 'katherine.johnson@example.com', role: 'Member', status: 'Invited', initials: 'KJ' }
];

/** User management section inside Settings (placeholder data). */
export function AdminUsersPage() {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <p className="text-muted-foreground text-sm">
          Manage workspace members and roles (placeholder data).
        </p>
        <Button size="sm">Invite user</Button>
      </div>
      <Card>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>User</TableHead>
                <TableHead>Role</TableHead>
                <TableHead className="text-right">Status</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {userRows.map((row) => (
                <TableRow key={row.email}>
                  <TableCell>
                    <div className="flex items-center gap-3">
                      <Avatar>
                        <AvatarFallback className="text-xs">{row.initials}</AvatarFallback>
                      </Avatar>
                      <div>
                        <p className="font-medium">{row.name}</p>
                        <p className="text-muted-foreground text-xs">{row.email}</p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge variant={row.role === 'Admin' ? 'default' : 'outline'}>
                      {row.role === 'Admin' && <ShieldIcon className="size-3" />}
                      {row.role}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-right">
                    <Badge variant={row.status === 'Active' ? 'secondary' : 'outline'}>
                      {row.status}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
